import { DEFINITIONS_BASE_PATH } from './definitions-base-path.js';

const base = `${DEFINITIONS_BASE_PATH}/scale`;

export const riskAnalysisTabsConfig = {
  basePath: base,
  tabs: [
    {
      id: "cia-matrix",
      path: `${base}/cia-matrix`,
      pageKey: "definitionsScaleCiaMatrix",
    },
    {
      id: "risk-assessment-matrix",
      path: `${base}/risk-assessment-matrix`,
      pageKey: "definitionsScaleRiskAssessmentMatrix",
    },
    {
      id: "bia-impact-scale",
      path: `${base}/bia-impact-scale`,
      pageKey: "definitionsScaleBiaImpact",
    },
  ],
};
